<template>
  <div class="info-chart-2">
    <div class="TITLESTYLE">解禁集中到期时间</div>
    <div style="display: flex; justify-content: flex-end">
      <div class="iconfont icon-fangda fff1" @click="show_chart_dialog = !show_chart_dialog"></div>
      <Download
        :dButtonsDownloads="down_btn_1"
        echartRefName="ic214491011"
        :excel_info="excel_info" />
    </div>
    <div ref="ic214491011" style="width: 100%; height: 360px; margin-top: 10px">
      <div v-if="!bar_data.length" class="ttt-tips">上市时间暂未公布，无法获得精确解禁日期图表</div>
    </div>
    <div>
      <el-table
        class="table1"
        :header-cell-style="tableStyle"
        :data="table_data"
        style="width: 100%"
        :height="table_data.length == 0 ? null : 580">
        <el-table-column
          prop="对象名称"
          show-overflow-tooltip
          align="left"
          label="对象名称"
          width="300">
        </el-table-column>

        <el-table-column prop="机构名称" show-overflow-tooltip label="机构名称" align="left">
        </el-table-column>

        <el-table-column align="center" sortable prop="限售期(月)" label="限售期(月)" width="150">
        </el-table-column>
        <el-table-column align="center" sortable prop="解禁日期" label="解禁日期" width="150">
        </el-table-column>

        <el-table-column
          align="center"
          width="160"
          sortable
          prop="限售份额(份)"
          label="限售份额(万份)">
          <template slot-scope="scope">
            <span>{{ toLocaleString(scope.row['限售份额(份)'] / 10000) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" prop="交易场所" label="交易场所">
        </el-table-column>
        <el-table-column
          align="left"
          show-overflow-tooltip
          width="300"
          prop="限售对象类型"
          label="限售对象类型">
        </el-table-column>
        <el-table-column
          align="center"
          width="160"
          sortable
          prop="限售金额"
          label="限售金额(万元)"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <span>{{ toLocaleString(scope.row['限售金额(万元)']) }}</span> -->
            <span>{{ (scope.row['限售金额'] / 10000).toFixed(1) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_options" />
  </div>
</template>

<script>
import { fnReturnTableStyle } from '@/utils/util';
import Download from '@/components/Basic/Download.vue';
import ChartDialog from '@/components/Basic/ChartDialog.vue';
import { debounce } from '@/utils';

export default {
  name: 'info-chart-2',
  props: {
    code: String,
  },
  components: { Download, ChartDialog },
  data() {
    return {
      show_chart_dialog: false,
      bar_data: [],
      table_data: [],
      chart_options: {},
      down_btn_1: [
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ],

      excel_info: Object.freeze({
        excel_data: [],
        json_fields: {
          对象名称: '对象名称',
          机构名称: '机构名称',
          '限售期(月)': '限售期(月)',
          解禁日期: '解禁日期',
          '限售份额(份)': '限售份额(份)',
          交易场所: '交易场所',
          限售对象类型: '限售对象类型',
          限售金额: '限售金额',
        },
        overviewName: '解禁集中到期时间',
      }),
    };
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
  },
  watch: {
    currentTheme() {
      this.debounceRender();
    },
  },
  methods: {
    toLocaleString(e) {
      return e.toLocaleString();
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
    debounceRender: debounce(function () {
      this.chartRender();
    }, 400),
    chartRender() {
      const data = this.bar_data;
      if (!data.length) {
        this.echart_instance && this.echart_instance.clear();
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.ic214491011);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const options = {
        grid: {
          top: this.ROOTFONTFIZE * (50 / 144),
          bottom: this.ROOTFONTFIZE * (20 / 144),
          // left: this.ROOTFONTFIZE * (50 / 144),
          left: '5%',
          right: this.ROOTFONTFIZE * (50 / 144),
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          triggerOn: 'mousemove|click',
          formatter: function (args) {
            let str = '';
            str += `${args[0].axisValueLabel}`;
            str += '<br>';
            args.forEach((node) => {
              let val = (Number(node.value['限售金额']) / 100000000).toFixed(2);
              str += `${node.marker}${node.seriesName}：${val}亿`;

              return str;
            });
            return str;
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,

          axisLine: {
            show: true,
            onZero: true, //轴线是否在0刻度轴上
          },

          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: this.ROOTFONTFIZE * (14 / 144),
            // rotate: 5,
            rotate: this.ROOTFONTFIZE * (14 / 144),
            margin: this.ROOTFONTFIZE * (20 / 144),
            show: true,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: {
          name: '单位：（亿元）',
          nameTextStyle: {
            color: OPTIONDATA.yAxis.nameTextStyle.color,
            fontSize: this.ROOTFONTFIZE * (14 / 144),
          },
          type: 'value',
          axisLine: {
            show: true,
          },
          offset: 30,
          axisTick: {
            show: false,
            //x轴刻度相关设置
            alignWithLabel: true,
          },
          axisLabel: {
            fontSize: this.ROOTFONTFIZE * (14 / 144),
            show: true,
            color: OPTIONDATA.yAxis.axisLabel.color,
            formatter: function (args) {
              if (args == 0) {
                return 0;
              } else {
                args = Number(args) / 100000000;
                let num = (parseInt(Math.abs(args)) + '').length >= 2 ? 1 : 2;
                args = args.toFixed(num);
                return args;
              }
            },
          },
          // data: [0, 1, 2, 3, 4],
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: OPTIONDATA.splitLine.lineStyle.color,
            },
          },
        },
        dataset: {
          dimensions: ['限售金额', '解禁日期'],
          source: data,
        },
        series: [
          {
            name: 'CREITs',
            itemStyle: {
              color: 'rgba(90, 202, 198, 1)',
            },
            barWidth: this.ROOTFONTFIZE * (37 / 144) + 'px',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              color: OPTIONDATA.title.textStyle.color,
              formatter: function (val) {
                const value = val.value['限售金额'];
                if (value !== 0) {
                  let val2 = Number(value) / 100000000;
                  let num = (parseInt(Math.abs(val2)) + '').length >= 2 ? 1 : 2;
                  return val2.toFixed(num) + '亿';
                } else {
                  return '';
                }
              },
            },
            encode: { x: '解禁日期', y: '限售金额' },
          },
        ],
      };

      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
    },
    async loadData() {
      const code = this.code;
      // const code = '508000.SH';
      const { data } = await this.$https.get('/api/restrict_holder?code=' + code + '&freq=M');
      if (data.code !== 200){
        if(data.msg==='0'){
          return this.$message.error("暂无数据");
        }
        return this.$message.error(data.msg);
      }
      const { table = [], bar = [] } = data.data;
      this.bar_data = Object.freeze(bar);
      this.table_data = Object.freeze(table);
      this.excel_info = Object.freeze({
        ...this.excel_info,
        excel_data: table,
      });
      this.debounceRender();
    },
  },
  mounted() {
    this.loadData();
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
  },
};
</script>

<style scoped lang="less">
.info-chart-2 {
  position: relative;
  height: calc(var(--ROOTFONTFIZE) * (500 / 144));
  overflow: auto;
  .TITLESTYLE {
    font-size: calc(var(--ROOTFONTFIZE) * (22 / 144));
    font-weight: 700;
    letter-spacing: 0px;
    line-height: calc(var(--ROOTFONTFIZE) * (28 / 144));
    color: var(--chart_title);
    // margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144));
    // margin-bottom: calc(var(--ROOTFONTFIZE) * (30 / 144));
    display: flex;
    justify-content: space-between;
  }
  .fff1 {
    position: unset;
    margin-right: 20px;
    margin-top: 4px;
  }
  .ttt-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: var(--chart_title);
    font-size: calc(var(--ROOTFONTFIZE) * (22 / 144));
  }
}
</style>
